export default __webpack_public_path__ + "static/media/ticket15.51db67db.jpg";